import React from 'react'
import styles from '~/styles/molecules/navigation/navigation.module.scss'

import { SpaceColor } from '~/common/define/color'
import { GeneralIconTag, IconTag } from '~/common/define/icon'
import NavigationMainItemList from '~/components/molecules/navigation/main/NavigationMainList'
import { NavigationMainItemVar } from '~/components/molecules/navigation/main/NavigationMainItem'
import Icon, { IconColor, IconFrame, IconSize } from '~/components/atoms/icon/Icon'
import NavigationMainNew from '~/components/molecules/navigation/main/NavigationMainNew'
import InternalLink from '~/components/atoms/link/InternalLink'
import TooltipWrapper from '~/components/wrapper/tooltip/TooltipWrapper'

interface Props {
  title: string
  iconTag: IconTag
  color: SpaceColor
  items: NavigationMainItemVar[]
  newLink: string
  newTooltipText: string
  newLinkText?: string
}

const NavigationMain = ({title, iconTag, color, items, newLink, newTooltipText, newLinkText = null}: Props) => {
  return (
    <div className={styles.main}>
      <div className={styles.main__title}>
        <span className={styles.main__title__icon}>
          <Icon tag={iconTag} size={IconSize.SMALL} fillColor={color}/>
        </span>
        <span className={styles.main__title__text}>
          {title}
        </span>
        <style jsx>{`
          span {
            color: ${color};
          }
        `}</style>
        <TooltipWrapper text={newTooltipText} className={styles.main__title__add}>
          <InternalLink link={newLink}>
            <Icon tag={GeneralIconTag.ADD_CROSS} size={IconSize.X_SMALL} fillColor={IconColor.WHITE}
                  frame={IconFrame.CIRCLE} clickableColor={color} bgColor={color}/>
          </InternalLink>
        </TooltipWrapper>
      </div>
      <NavigationMainItemList items={items}/>
      {newLinkText &&
        <NavigationMainNew link={newLink} text={newLinkText}/>
      }
    </div>
  )
}

export default NavigationMain